import { storeToRefs } from "pinia";

// Centralised user-identity tracking. On login / signup / session hydration it
// pushes user_identify to the GTM dataLayer AND fires the Dotdigital identify
// event from the same watcher; on logout it pushes user_anonymize. Centralising
// means every auth path emits without each call site having to remember. The
// Dotdigital call is a no-op unless the template enables it + marketing consent
// is granted (gating in useDotdigital).
export default defineNuxtPlugin(() => {
	if (!import.meta.client) return;

	const { getUser } = storeToRefs(userStore());
	const { userIdentify, userAnonymize } = useGtmEvents();
	const { identify } = useDotdigital();

	watch(
		() => getUser.value?.Email,
		(email, previousEmail) => {
			if (email) {
				userIdentify(email);
				identify({ email });
				return;
			}
			if (previousEmail) {
				userAnonymize();
			}
		},
		{ immediate: true }
	);
});
